(() => {
  if (window.ltifyWishlistLoaded) return;
  window.ltifyWishlistLoaded = true;

  const storageKey = 'ltify_wishlist_v1';

  function readWishlist() {
    const stored = JSON.parse(
      localStorage.getItem(storageKey) || '[]'
    );

    if (!Array.isArray(stored)) return [];

    return [...new Set(
      stored.filter(item => typeof item === 'string' && item)
    )];
  }

  function updateButtons() {
    let wishlist;

    try {
      wishlist = readWishlist();
    } catch (error) {
      return;
    }

    document.querySelectorAll('.ltify-wishlist-button')
      .forEach(button => {
        const saved = wishlist.includes(
          button.dataset.productHandle
        );

        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute(
          'aria-label',
          saved ? 'Remove from wishlist' : 'Add to wishlist'
        );
      });

    document.querySelectorAll('[data-wishlist-count]')
      .forEach(element => {
        element.textContent = wishlist.length;
      });

    document.dispatchEvent(new CustomEvent(
      'ltify:wishlist-updated',
      { detail: { handles: wishlist } }
    ));
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(
      '.ltify-wishlist-button'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) return;

    try {
      const wishlist = readWishlist();
      const nextWishlist = wishlist.includes(handle)
        ? wishlist.filter(item => item !== handle)
        : [...wishlist, handle];

      localStorage.setItem(
        storageKey,
        JSON.stringify(nextWishlist)
      );

      updateButtons();
    } catch (error) {
      alert(
        'Unable to save your wishlist. Please allow browser storage and try again.'
      );
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateButtons,
      { once: true }
    );
  } else {
    updateButtons();
  }

  window.addEventListener('pageshow', updateButtons);

  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) {
      updateButtons();
    }
  });

  document.addEventListener(
    'shopify:section:load',
    updateButtons
  );

  let updateQueued = false;

  const observer = new MutationObserver(mutations => {
    const hasNewElements = mutations.some(mutation =>
      Array.from(mutation.addedNodes).some(
        node => node.nodeType === 1
      )
    );

    if (!hasNewElements || updateQueued) return;

    updateQueued = true;
    requestAnimationFrame(() => {
      updateQueued = false;
      updateButtons();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
